var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-layout",class:{'height--fix':_vm.heightFix}},[_c('div',{staticClass:"main-layout__inner"},[_c('div',{staticClass:"main-layout__contents",attrs:{"id":"container"}},[_c('router-view')],1),_c('div',{staticClass:"main-layout__footer"},[_c('FooterInfo'),_c('tFooterInfo'),_c('Footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }